<div #anchor class="datetime-range-picker" >
	<div class="from-date">
		<label style="margin-bottom: 0px">{{'from' | cpLabelTranslate}}:</label>
		<kendo-datetimepicker
				[ngClass]="{'kendo-datetime-picker-error': !validDateTimeRange}"
				[format]="format"
				[value]="fromDateTime"
				[max]="toDateTime"
				(valueChange)="handleSelectionFromChange($event); dateTimeRangeValidation()"
				(close)="onFromDateTimePickerClose($event)">
		</kendo-datetimepicker>
	</div>
	<div class="to-date" >
		<label style="margin-bottom: 0px">{{'to' | cpLabelTranslate}}:</label>
		<kendo-datetimepicker
			#todatetimepicker
			[ngClass]="{'kendo-datetime-picker-error': !validDateTimeRange}"
			[format] ="format"
			[value]="toDateTime"
			[min]="fromDateTime"
			(valueChange)="handleSelectionToChange($event); dateTimeRangeValidation() ">
		</kendo-datetimepicker>
	</div>
</div>


